/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { TimeClockInitializer as GlobalInitializer } from '@teamworks/global';

export class TimeClockInitializer {

  static initialize() {
    GlobalInitializer.initialize();
  }

}
